export default {
    root: {
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
    }
};
